import { formatGbp } from "../money-format";
import type { NoContractRow } from "@/types/spend";

export const TOP_OPTIONS = ["10", "25", "50", "all"] as const;
export type TopOption = (typeof TOP_OPTIONS)[number];

/** "2026-09-01" -> "2026-09", the month query parameter of the report endpoints. */
export const monthParam = (month: string) => month.slice(0, 7);

export const gbp = (value: string) => formatGbp(value) ?? value;

export const matchesSearch = (search: string, values: (string | null)[]) => {
  const needle = search.trim().toLowerCase();
  return !needle || values.some(value => value?.toLowerCase().includes(needle));
};

export const limitRows = <Row>(rows: Row[], top: TopOption) => (top === "all" ? rows : rows.slice(0, Number(top)));

export const GRACE_OPTIONS = [0, 7, 14, 30, 60, 90] as const;

/** The API sends the alphabetically first and last names plus the count, never the whole list. */
export const supplierLabel = (row: Pick<NoContractRow, "supplier_names" | "supplier_name_count">) => {
  const [first, last] = row.supplier_names;
  if (!first) return "—";
  if (row.supplier_name_count <= 1) return first;
  if (row.supplier_name_count === 2 && last) return `${first}, ${last}`;
  return `${first} and ${row.supplier_name_count - 1} others`;
};

/** Decimal strings from the API, as numbers so spreadsheets sum them and a minus sign is not neutralised. */
export const amount = (value: string) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : value;
};

// The reports scan a whole organization's spend; revisiting a tab within a minute reuses the cached result.
export const REPORT_REFETCH_SECONDS = 60;

// Matches MAX_GRACE in the backend report schemas.
export const MAX_GRACE_DAYS = 365;

/** "-£10.00 (2)": the value and number of credit notes. */
export const creditNotes = (credits: string, count: number) => `${gbp(credits)} (${count})`;
